import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=73c0951a&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&id=73c0951a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0951a",
  null
  
)

export default component.exports